import { Component, Input, OnInit, SimpleChanges } from "@angular/core";

@Component({
	selector: "caass-group-import-column-table",
	templateUrl: "./group-import-column-table.component.html",
	styleUrls: ["./group-import-column-table.component.css"],
})
export class GroupImportColumnTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.UpdateData();
	}

	// ngOnChanges(){
	//   // this.UpdateData();
	// }

	ngOnChanges(changes: SimpleChanges): void {
		// console.log("Changes");
		// console.log(changes);

		for (const propName in changes) {
			if (changes.hasOwnProperty(propName)) {
				// console.log(propName);
				switch (propName) {
					case "lstColumnTable":
						this.UpdateData();
				}
			}
		}
	}

	/////////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////////

	@Input() ImportStatusID: number = 0;
	@Input() lstColumnTable: any = [];

	lstOptions: any = [];

	lstColumnOptions: any = [];
	lstSingleColumnOptions: any = [
		{
			ID: 0,
			Desc: "PersonID",
		},
		{
			ID: 1,
			Desc: "StudentID",
		},
	];

	lstMultipleColumnOptions: any = [
		{
			ID: -1,
			Desc: "Don't Import",
		},
		{
			ID: 0,
			Desc: "PersonID",
		},
		{
			ID: 1,
			Desc: "StudentID",
		},
		{
			ID: 2,
			Desc: "Group Name",
		},
		{
			ID: 3,
			Desc: "Group ID",
		},
		// {
		//   ID: 4,
		//   Desc: "School Number"
		// }
	];

	TabCols = [];
	OptArray: any = [];

	MaxWidth: any = "800px";

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	/////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////////////
	UpdateData() {
		var TableWidth = 0;
		var Popup_Width = window.innerWidth - 80;

		if (this.lstColumnTable == undefined || this.lstColumnTable.length == 0) {
			this.lstOptions = [];
			this.lstColumnOptions = [];

			this.MaxWidth = TableWidth + "px";
			return;
		}

		var colCount = this.lstColumnTable[0].length;

		this.TabCols = [];
		this.OptArray = [];
		for (var i = 0; i < colCount; i++) {
			this.TabCols.push({
				field: i,
				header: "Column " + (i + 1),
			});
			this.OptArray.push(colCount == 1 ? 0 : -1);
		}

		if (colCount == 1) {
			this.lstColumnOptions = this.lstSingleColumnOptions;

			this.MaxWidth = "400px";
		} else {
			this.lstColumnOptions = this.lstMultipleColumnOptions;

			TableWidth = colCount * 200;
			if (TableWidth > Popup_Width) {
				TableWidth = Popup_Width;
			}

			this.MaxWidth = TableWidth + "px";
		}
	}

	/////////////////////////////////////////////////////////////////////////////////
}
